(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sx-manga-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sx-manga-story')) {
  customElements.define('sx-manga-story', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.querySelectorAll('[data-manga-open]').forEach(button => button.addEventListener('click', () => {
        this.opener = button;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }));
      this.querySelector('[data-manga-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const box = this.dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close(); } });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        if (this.productTarget) { this.productTarget.scrollIntoView({behavior:'auto',block:'center'}); this.productTarget = null; }
        else if (this.opener && this.opener.isConnected) this.opener.focus({preventScroll:true});
      });
      this.querySelector('[data-manga-zoom]').addEventListener('click', event => { const zoomed = this.dialog.classList.toggle('is-zoomed'); event.currentTarget.setAttribute('aria-pressed', String(zoomed)); });
      const productLink = this.querySelector('[data-manga-product]');
      if (productLink) productLink.addEventListener('click', event => {
        const target = this.dataset.productAnchor ? Array.from(document.querySelectorAll('[id^="custom-carousel-"]')).find(element => element.id.endsWith(this.dataset.productAnchor)) : null;
        if (target) { event.preventDefault(); this.productTarget = target; this.dialog.close(); }
      });
    }
    disconnectedCallback() { if (this.dialog && this.dialog.open) { this.dialog.close(); document.body.style.overflow = this.previousOverflow || ''; } }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sx-night-film"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sx-responsive-media')){customElements.define('sx-responsive-media',class extends HTMLElement{
connectedCallback(){this.sync=()=>{this.querySelectorAll('video').forEach(video=>{const visible=getComputedStyle(video.parentElement).display!=='none';if(visible&&!document.hidden){video.muted=true;video.defaultMuted=true;video.playsInline=true;video.play().catch(()=>{});}else{video.pause();}});};this.onReady=()=>this.sync();this.breakpoint=matchMedia('(max-width:749px)');this.breakpoint.addEventListener('change',this.sync);document.addEventListener('visibilitychange',this.sync);document.addEventListener('pointerdown',this.sync,{passive:true});document.addEventListener('touchstart',this.sync,{passive:true});this.addEventListener('loadeddata',this.onReady,true);this.addEventListener('canplay',this.onReady,true);this.observer=new MutationObserver(this.sync);this.observer.observe(this,{childList:true,subtree:true});this.frame=requestAnimationFrame(this.sync);}
disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.breakpoint?.removeEventListener('change',this.sync);document.removeEventListener('visibilitychange',this.sync);document.removeEventListener('pointerdown',this.sync);document.removeEventListener('touchstart',this.sync);this.removeEventListener('loadeddata',this.onReady,true);this.removeEventListener('canplay',this.onReady,true);}
});}

  } catch(e) { console.error(e); }
})();
})();
